<div class="container" id="digi-slider-menu">
  <div
    class="slider-menu-box"
    [style.width]="isCollapsed ? '80px' : sliderMenuWidth"
    [class.collapsed]="isCollapsed"
  >
    <div class="menu-title">
      <img *ngIf="avater" [src]="avater" class="menu-img" />
      <span>{{ title }}</span>
    </div>
    <div [style.height]="bodyMenuHeight" class="body-menu">
      <bcsc-digi-menu
        [menuItems]="sliderMenuItems"
        [isCollapsed]="isCollapsed"
        [selectItem]="selectItem"
        (onMenuClick)="onMenuClick($event)"
      ></bcsc-digi-menu>
    </div>
    <div *ngIf="footerMenuItems.length" class="footer-menu">
      <bcsc-digi-menu
        [menuItems]="footerMenuItems"
        [isCollapsed]="isCollapsed"
        [selectItem]="selectItem"
        (onMenuClick)="onMenuClick($event)"
      ></bcsc-digi-menu>
    </div>
    <div
      *ngIf="footerInfo?.title"
      class="footer-info"
      [class.margin-top-auto]="footerMenuItems.length === 0"
      [class.isCollapsed]="isCollapsed"
    >
      <div class="footer-info-content">
        <bcsc-digi-icon
          class="footer-info-icon"
          [type]="footerInfo.icon || 'digi-dashboard'"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? footerInfo.title : ''"
        ></bcsc-digi-icon>
        <span *ngIf="!isCollapsed" class="footer-info-title">{{
          footerInfo.title
        }}</span>
      </div>
    </div>
    <div (click)="onToggleCollapsed()" class="toggle-icon">
      <bcsc-digi-icon type="digi-menu" class="menu-icon"></bcsc-digi-icon>
      <bcsc-digi-icon
        [type]="isCollapsed ? 'digi-right-arrow' : 'digi-left-arrow'"
        class="arrow"
      ></bcsc-digi-icon>
    </div>
  </div>
  <div
    class="app-content-box"
    [style.width]="
      isCollapsed ? 'calc(100% - 80px)' : 'calc(100% - ' + sliderMenuWidth + ')'
    "
  >
    <div class="slider-bar-box">
      <div class="breadcrumb-box">
        <bcsc-digi-breadcrumb
          [breadcrumbItems]="breadcrumbItems"
        ></bcsc-digi-breadcrumb>
      </div>
      <div class="extend">
        <ng-content select="[extend]"></ng-content>
      </div>
    </div>
    <div class="app-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
